const tableHeaders = [
  {
    label: 'Level',
    key: 'stepName',
    sortable: false,
  },
  {
    label: 'Name',
    key: 'name',
    sortable: false,
  },
  {
    label: 'Title',
    key: 'title',
    sortable: false,
  },
  {
    label: 'Date',
    key: 'createdAt',
    filter: 'date',
    sortable: false,
  },
  {
    label: 'Status',
    key: 'result',
    sortable: false,
  },
];

export default () => tableHeaders;
